import { Notification } from "constant/notifications";
import { useEffect, useState } from "react";
import { FaCheck, FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { updateFavorites } from "redux/userRedux";
import {
  ArtistPayload,
  CheckingFollowingStatus,
  followArtist,
} from "services/favorite/favoriteService";
import {
  triggerErrorNotification,
  triggerSuccessNotification,
} from "utils/notification";

function SubscribeCreator({
  creatorId,
  user,
  creator,
  setShowLoginModal,
}: any) {
  const dispatch = useDispatch<any>();
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const favorite = useSelector((state: any) => state?.user?.userFavorites);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const checkFollowingStatus = async () => {
    if (!loggedInUser) return;
    try {
      setIsLoading(true);
      const resp = await CheckingFollowingStatus(creatorId, "artist");
      if (resp?.status === true) {
        setIsLiked(resp?.data?.data);
      }
    } catch (err) {
      console.log("err :::", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (loggedInUser) {
      checkFollowingStatus();
    }
  }, [creatorId]);

  const addFavToRedux = () => {
    const newFavoriteArtist = {
      id: creator?.id,
      loveable_id: creator?.id,
      loveable_type: "App\\Models\\Artist",
      ...creator,
    };

    const updatedArtistData = [
      ...(favorite?.favorite_artists || []),
      newFavoriteArtist,
    ];

    const updatedFavorite = {
      ...favorite,
      favorite_artists: updatedArtistData,
    };

    dispatch(updateFavorites(updatedFavorite));
  };

  const removeFavFromRedux = () => {
    const updatedArtistData = favorite?.favorite_artists?.filter(
      (favArtist: any) =>
        Number(favArtist?.loveable_id) !== Number(creator?.id),
    );

    const updatedFavorite = {
      ...favorite,
      favorite_artists: updatedArtistData,
    };

    dispatch(updateFavorites(updatedFavorite));
  };

  //Like Artist
  const handleFavorite = async () => {
    if (!loggedInUser) {
      setShowLoginModal(true);
      return;
    } else {
      const favoriteArtist: ArtistPayload = {
        id: creatorId,
        user_type: "artist",
        is_follow: true,
      };

      if (!isLiked) {
        await followArtist(favoriteArtist)
          .then((res: any) => {
            if (res) {
              setIsLiked(true);
              if (user && user?.id === loggedInUser.id) {
                addFavToRedux();
              }
              triggerSuccessNotification(Notification.Followed);
            } else {
              setIsLiked(false);
              triggerErrorNotification(Notification.FavError);
            }
          })
          .catch((e) => {
            setIsLiked(true);
            triggerErrorNotification(Notification.FavError);
          });
      } else {
        await followArtist({
          id: creatorId,
          user_type: "artist",
          is_follow: false,
        })
          .then((res: any) => {
            if (res) {
              if (user && user?.id === loggedInUser.id) {
                removeFavFromRedux();
              }
              triggerSuccessNotification(Notification.Unfollowed);
              setIsLiked(false);
            } else {
              setIsLiked(true);
              triggerErrorNotification(Notification.FavError);
            }
          })
          .catch((e) => {
            setIsLiked(true);
            triggerErrorNotification(Notification.FavError);
          });
      }
    }
  };

  return (
    <>
      {!isLoading ? (
        <button
          onClick={handleFavorite}
          className={`flex items-center justify-center gap-2 rounded-full px-7 py-3 text-base font-bold transition-all duration-300 ease-in-out max-sm:w-full max-sm:px-5 max-sm:text-[13px] ${
            isLiked
              ? "border-2 border-white/20 bg-white/5 text-white hover:border-[var(--red)]/60 hover:bg-white/10"
              : "border-2 border-transparent bg-[var(--red)] text-white shadow-lg shadow-[var(--red)]/30 hover:scale-[1.03] hover:brightness-110"
          }`}
        >
          {isLiked ? (
            <>
              Following <FaCheck className="!text-[var(--green)]" />
            </>
          ) : (
            <>
              <FaPlus className="text-[13px]" /> Follow
            </>
          )}
        </button>
      ) : (
        <div className="flex items-center justify-center bg-[#1a1919] w-32 h-10 animate-pulse gap-2 rounded-full px-7 py-3 max-sm:w-full max-sm:px-5"></div>
      )}
    </>
  );
}

export default SubscribeCreator;
